import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useRenewalEmailService from "../../../hooks/useRenewalEmailService";
import { RenewalActions } from "../../../types/Order/RenewalEmail";
import RenewalDeleteConfirmation from "./RenewalDeleteConfirmation";
import RenewalRenewCurrent from "./RenewalRenewCurrent";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import { useThemeContext } from "../../theme/ThemeContext";
import { Theme } from "../../../constant/Theme";

const RenewalLandingPage = () => {
  const {
    orderId = "",
    orderItemId = "",
    renewalEmailId,
    action,
  } = useParams();
  const renewalEmailService = useRenewalEmailService();
  const { theme } = useThemeContext();
  const isDark = theme === Theme.DARK;

  const [linkClickedDone, setLinkClickedDone] = useState(false);

  useEffect(() => {
    if (!renewalEmailId) return;

    renewalEmailService
      .markLinkClicked(renewalEmailId)
      .finally(() => setLinkClickedDone(true));
  }, []);

  const renderContent = () => {
    if (!linkClickedDone) {
      return <LoadingSpinner message="Please wait..." />;
    }

    if (action === RenewalActions.RemoveData) {
      return <RenewalDeleteConfirmation orderItemId={orderItemId} />;
    }

    if (action === RenewalActions.RenewCurrent) {
      return (
        <RenewalRenewCurrent orderId={orderId} orderItemId={orderItemId} />
      );
    }

    return (
      <>
        <h1>Renew Your Licence</h1>
        <p>Renewal information will be displayed here.</p>
      </>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: isDark ? "#121212" : "#ffffff",
        color: isDark ? "#ffffff" : "#000000",
      }}
    >
      {renderContent()}
    </div>
  );
};

export default RenewalLandingPage;
